import React, { useState, useEffect, useContext } from 'react';

import ddo from "../../ddo";

import * as net from "../../lib/net";
import Dt_Cal from "../../lib/ui/dt_cal";
import * as utils from "../../assets/utils";
import Td_Sel from "../../lib/ui/td_sel";
import {format} from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class TH_Week extends React.Component {
  constructor(props, context) {
    super(props);

      this.dt_fd = React.createRef();
      this.dt_td = React.createRef();

    this.store = props.store;
      this.ta = props.store.ta;

    this.state = {};
    this.state.avd = "01";
    this.state.tha = [];
    this.state.aa = [];
      this.state.wnds = {};
      this.state.sortid = "";
      this.state.sortdir = 1;
      this.state.tot = {};

      this.state.today = new Date();
      var dts = format(this.state.today, "yyyy-MM-dd");
      this.state.fdat = dts;
      this.state.tdat = dts;

      if(this.ta && this.ta.base) {
          this.state.fdat = this.ta.base.fdat;
          this.state.tdat = this.ta.base.tdat;
      }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
      ddo.cache.fkn = "";
  }
  componentDidMount() {
      ddo.cache.fkn = "VECKA";
    this.week();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        css.overflow = "auto";
        return css;
    }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

    dt_fdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ fdat: dts });
    }
    dt_tdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ tdat: dts });
    }
    oneday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_td.current.updateDt(this.state.fdat);
    }
    addday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateAdd();
        this.dt_td.current.updateAdd();
    }
    subday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateSub();
        this.dt_td.current.updateSub();
    }

    week_edit(row) {
        var self = this;
        var wnds = {};
        wnds.eeper = 1;
        wnds.fdat = this.state.fdat;
        wnds.tdat = this.state.tdat;
        wnds.eeo = row;
        this.setState({wnds: wnds});
    }

  week() {
    var self = this;
    var prm = {};
    prm.req = "ta.ta_th.tps_ft";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ tha: ret.rca, tot: ret.tot }, function() {
            self.syncTb("weekTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var tha = self.state.tha;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ) {
            if(sortdir) tha.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
            else tha.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        }
        self.setState({ tha: tha, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }
    show_text(row) {
        var txt = "";
        var avd = row.avd;
        var dpa = this.props.store.ta.dpa;
        //var keys = Object.keys(dpa);
        for(var o of dpa) {
            if(o.avdelning == avd) txt = o.namn;
        }
        //if(dpo[avd] != undefined) {
        //    txt = dpo.namn;
        //}
        txt = txt.toString().toswe();
        return txt;
    }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row flex-space-between">
        <div className="label_h03">VECKA</div>
        <div className="flex-row">
            <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
            <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
            <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
            <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
            <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>
        <button className="btn btn-hw-blue w150" onClick={() => this.week() } aria-label="System" >
            Uppdatera
        </button>
    </div>
    <div className="divider_blue"></div>

        <div id="weekTable" className="web-col">
            <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.th_style("avd") } onClick={() => this.tb_sort("avd") }>Avdelning <i className={ this.th_icon("avd") }></i></th>
                    <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }>Text <i className={ this.th_icon("avd") }></i></th>
                    <th style={ this.th_style("nrp") } onClick={() => this.tb_sort("nrp") }>Antal <i className={ this.th_icon("nrp") }></i></th>
                    <th style={ this.th_style("netto") } onClick={() => this.tb_sort("netto") }>Nettotid <i className={ this.th_icon("netto") }></i></th>
                    <th style={ this.th_style("rast") } onClick={() => this.tb_sort("rast") }>Rast <i className={ this.th_icon("rast") }></i></th>
                    <th style={ this.th_style("brutto") } onClick={() => this.tb_sort("brutto") }>Bruttotid <i className={ this.th_icon("brutto") }></i></th>
                    <th style={ this.th_style("ob1") } onClick={() => this.tb_sort("ob1") }>OB1 <i className={ this.th_icon("ob1") }></i></th>
                    <th style={ this.th_style("ob2") } onClick={() => this.tb_sort("ob2") }>OB2 <i className={ this.th_icon("ob2") }></i></th>
                    <th style={ this.th_style("nreg") } onClick={() => this.tb_sort("nreg") }>Regs <i className={ this.th_icon("nreg") }></i></th>
                    <th></th>
                </tr>
                </thead>
            </table>
            <div className="tb-cdi" style={ this.tb_style() }>
                <table className="table table-bordered table-hover tb">
                    <tbody>
                    { this.state.tha.map((row, key) =>
                        <tr key={key} onDoubleClick={() => this.dep_edit(row) }>
                            <td>{ row.avd }</td>
                            <td>{ this.show_text(row) }</td>
                            <td className="text-center">{ utils.toNum(row.nrp) }</td>
                            <td className="text-center">{ utils.toMinTid(row.netto) }</td>
                            <td className="text-center">{ utils.toMinTid(row.rast) }</td>
                            <td className="text-center">{ utils.toMinTid(row.brutto) }</td>
                            <td className="text-center">{ utils.toMinTid(row.ob1) }</td>
                            <td className="text-center">{ utils.toMinTid(row.ob2) }</td>
                            <td className="text-center">{ row.nreg }</td>
                            <td>
                                <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
        <div className="divider_blue"></div>
        <div className="flex-row">
            <div className="txt_18">TOTAL NETTO: { utils.toMinTid(this.state.tot.netto) }</div>
            <div className="flex"></div>
            <div className="flex"></div>
            <div className="txt_18">TOTAL BRUTTO: { utils.toMinTid(this.state.tot.brutto) }</div>
        </div>
   </div>
  );
    }
}
export default TH_Week;
